import React, { useState } from "react";
import { Form } from "react-bootstrap";

import { ChromePicker } from "react-color";

const ColorPicker = ({
  title = "Background Color",
  onColorChange = null,
  color,
}) => {
  const [currentColor, setColor] = useState(color || "#fff");
  const [showPicker, togglePickerView] = useState(false);

  return (
    <div className="colorPicker">
      <Form.Label>{title}</Form.Label>
      <div
        role="button"
        tabIndex="0"
        className="selectedColor"
        aria-label="Pick Color"
        onClick={() => togglePickerView(true)}
        onKeyPress={() => togglePickerView(true)}
      >
        <div className="color" style={{ background: currentColor }} />
      </div>
      {showPicker ? (
        <div className="pickerPopover">
          <div id="tail1" />
          <div
            role="button"
            tabIndex="0"
            aria-label="Pick Color"
            className="cover"
            onClick={() => togglePickerView(false)}
            onKeyPress={() => togglePickerView(false)}
          />
          <ChromePicker
            color={currentColor}
            onChangeComplete={(selected) => {
              console.log("chrome picker", selected);
              setColor(selected.hex);
              if (onColorChange) onColorChange(selected.hex);
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ColorPicker;
